export default "__VITE_ASSET__CsCcQp9a__"